import { render, staticRenderFns } from "./BeforeFooter.vue?vue&type=template&id=338882d2&scoped=true&"
import script from "./BeforeFooter.vue?vue&type=script&lang=js&"
export * from "./BeforeFooter.vue?vue&type=script&lang=js&"
import style0 from "./BeforeFooter.vue?vue&type=style&index=0&id=338882d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338882d2",
  null
  
)

export default component.exports